export enum LicenceEnhancementsUnlimited {
  EXIST = '1',
  NOT_EXIST = '0'
}
